import * as React from 'react'
import {
  redirectUrlBuilder,
  SubscribeToConvertkitForm,
} from '@skillrecordings/convertkit-react-ui'
import {useRouter} from 'next/router'
import common from '../text/common'

export const PrimaryNewsletterCta: React.FC<
  React.PropsWithChildren<unknown>
> = ({children}) => {
  const router = useRouter()
  return (
    <section
      aria-label="Email course sign-up"
      id="subscribe"
      className="relative flex flex-col items-center justify-center overflow-hidden sm:px-16 px-5 lg:pb-32 sm:pb-24 pb-16 sm:pt-24 pt-10"
    >
      {children ? (
        children
      ) : (
        <>
          <h2 className="max-w-lg font-heading mx-auto -mt-4 sm:text-4xl text-3xl leading-none text-center md:text-5xl font-bold sm:mt-0">
            Join the Newsletter
          </h2>
          <h3 className="max-w-md leading-tight pt-6 pb-16 text-xl text-center">
            Learn stuff!
          </h3>
        </>
      )}
      <SubscribeToConvertkitForm
        onSuccess={(subscriber: any) => {
          if (subscriber) {
            const redirectUrl = redirectUrlBuilder(subscriber, '/confirm')
            router.push(redirectUrl)
          }
        }}
        actionLabel={`${common['primary-newsletter-button-cta-label']} →`}
      />
      <p className="pt-8 opacity-70 text-sm">
        We respect your privacy. Unsubscribe at any time.
      </p>
    </section>
  )
}
